import api from '../api';

/**
 * Adds a reservation for a specified table.
 *
 * @param {Date} startTime - The start time of the reservation.
 * @param {Date} endTime - The end time of the reservation.
 * @param {string} tableCode - The code of the table for the reservation.
 *  * @param {string} storeCode - The code of the store for the reservation.
 * @return {Promise<Object>} - The response from the API.
 * @throws {Error} - If the request fails.
 */
const addReservation = async (startTime, endTime, tableCode,storeCode) => {
  const endpoint = `${process.env.REACT_APP_API_ENDPOINT}/api/store/addReservation`;
  const requestData = {
    start_time: startTime,
    end_time: endTime,
    table_code: tableCode,
    store_code:storeCode
  };
  try {

    const response = await api.post(endpoint,requestData);

    return response.data;
  } catch (error) {
    console.error('Error adding reservation:', error);
    throw error;
  }
}

export default addReservation;
